export default __webpack_public_path__ + "static/activities_cover_mobile-f5734c64d0398682ae13927d4d64600f.jpg";